import React, { useState, useEffect } from "react";
import { get, camelCase } from "lodash";
import { Row, Col } from "react-bootstrap";
import { HomeWidgetCard, LoaderWrapper } from "../../components";
import { getHomePageDetails, getAllCounts } from "../../services";
import { useComponentDidUpdate, useRequest } from "../../abstracts";
import permissions from "../../mocks/menuPermissions.json";
import authService from "../../components/api-authorization/AuthorizeService";

const HomeContainer = (props) => {
  const { history } = props;
  const [fetchCounts, setFetchCounts] = useState(true);
  const [roleName, setRoleName] = useState("VOU");
  const { response, loading } = useRequest({
    method: getHomePageDetails,
  });
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const { response: countsResponse, loading: isCountsLoading } = useRequest({
    method: getAllCounts,
    payload: null,
  });
  const onAddClick = (e, item) => {
    e.preventDefault();
    history.push(item.routeToAdd);
  };

  const onDidUpdate = () => {
    if (!loading) {
      setFetchCounts(false);
    }
  };

  useComponentDidUpdate(onDidUpdate, [loading]);
  return (
    <LoaderWrapper isLoading={loading}>
      <Row className="home-container">
        {(response || []).map((item, index) => (
          <div key={index}>
            {permissions[roleName]["menuItems"][
              camelCase(item.tileName)
            ]?.includes("R") && (
              <HomeWidgetCard
                name={item.tileName}
                count={get(countsResponse, camelCase(item.tileName), "")}
                onAddClick={(e) => onAddClick(e, item)}
                isDisabled={!item.isEnabled}
                showAdd={item.hasAddIcon}
                link={item.routeToNavigateOnClick}
                imgUrl={item.imageUrl}
                isLoading={
                  (item.tileName == "Plan" ||
                    item.tileName == "Company" ||
                    item.tileName == "Employees") &&
                  isCountsLoading
                }
              />
            )}
          </div>
        ))}
      </Row>
    </LoaderWrapper>
  );
};

export default HomeContainer;
